export const makeId = (length: number) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = 62; // characters.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getExtension = (fileName: string): string => {
  return fileName.split(".").pop()?.toLowerCase() as string;
};

export const fileTypeCheck = (fileName: string) => {
  const extension = getExtension(fileName);
  if (extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "gif") {
    return true;
  }
  return false;
};

export const getFileSizeFromString = (size: string): number => {
  const fileSize = parseInt(size.match(/(\d+)/g)![0], 10);
  const fileUnit = size.match(/(\D+)/g)![0];
  // if (size !== `${fileSize}${fileUnit}`) return 0;
  switch (fileUnit) {
    case "KB":
      return fileSize * 1024;
    case "MB":
      return fileSize * 1048576; // 1024 * 1024;
    case "GB":
      return fileSize * 1073741824; // 1024 * 1024 * 1024;
    case "TB":
      return fileSize * 1099511627776; // 1024 * 1024 * 1024 * 1024;
    default:
      return 0;
  }
};

export const getFileSizeToString = (bytes: number, decimals = 1): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
